import React, { useEffect, useState } from 'react';
import Apis from '../../../../../api';
import PNormalInput from '../../../../common/NormalInput';
import PNormalTextArea from '../../../../common/NormalTextArea';
import { Radio, RadioChangeEvent } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/RootReducer';

type Props = {
    campaign_id?: string;
    campaignType: string;
    keywords?: string;
    onChangeFields: (data: { name: string; value: string | number | undefined }) => void;
    onChangeCampaignType: (data: RadioChangeEvent) => void;
    description?: string;
    name?: string;
    isValidate: boolean;
    error?: string;
    setUnsaveChanges: any;
    prevName?: any;
    setPrevName?: any;
};

const PInputNameDes: React.FC<Props> = ({ campaign_id, campaignType, keywords, onChangeCampaignType, onChangeFields, description, name, isValidate, error, setUnsaveChanges, prevName, setPrevName }) => {
    const campaignTypes = ["Prebid", "Keyword Campaign"];
    const user = useSelector((state: RootState) => state.user.user);
    const [userAccessToKeywordCampaign, setUserAccessToKeywordCampaign] = useState<boolean>(false);

    const onFormFieldChange = (data: { name: string; value: string | number | undefined }) => {
        const { name, value } = data;
        onChangeFields({
            name: name,
            value: value,
        });
        if (name === 'description') {
            setUnsaveChanges(true)
        }
    };
    const handleCheckCampaign = (value: string) => {
        if (prevName && name?.trim() !== prevName.trim()) {
            setUnsaveChanges(true)
            Apis.validateCampaignName({ campaign_name: value })
                .then(({ data }) => {
                    if (data.data.status === true) {
                        onChangeFields({
                            name: 'error',
                            value: '',
                        });
                    }
                })
                .catch((err) => {
                    if (err.response.data.data.status === false) {
                        onChangeFields({
                            name: 'error',
                            value: err.response.data.data.message,
                        });
                    }
                })
        }
    };

    //setting prevname for first time only
    useEffect(() => {
        if (name && !prevName) {
            setPrevName(name);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name])

    useEffect(() => {
        if (user) {
            const [name, domain] = user.email.split('@');
            if (user?.publisher_type === 'super_admin' || user?.publisher_type === 'admin' || ['masonkramer.net', 'freespoke.com'].includes(domain)) {
                setUserAccessToKeywordCampaign(true);
            }else{
                setUserAccessToKeywordCampaign(false);
            }
        }
    }, []);

    return (
        <div className="p-4 mt-3 bg-white rounded-md shadow-md">
            {userAccessToKeywordCampaign && (
                <div>
                    <label className="ml-1">
                        Select Campaign type
                        <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-2 mb-2">
                        <Radio.Group disabled={campaign_id ? true : false} onChange={onChangeCampaignType} value={campaignType} name="type">
                            {campaignTypes?.map((item, index) => <Radio key={index} value={item}>{item}</Radio>)}
                        </Radio.Group>
                    </div>
                    {isValidate && !campaignType && <span className="common_error">Please Select Campaign type</span>}
                </div>
            )}
            {userAccessToKeywordCampaign && campaignType !== 'Prebid' && (
                <div>
                    <PNormalTextArea className="md:rounded md:py-2 text-xs" rows={3} value={keywords} name="keywords" title="Campaign Keywords" onChange={onFormFieldChange} placeholder="Enter campagin keywords (seperate with comma)" />
                </div>
            )}
            <div>
                <PNormalInput
                    isRequired={true}
                    className="md:rounded md:py-2 text-xs"
                    value={prevName}
                    name="name"
                    title="Campaign Name"
                    onChange={(e) => setPrevName(e.value)}
                    placeholder="Enter campagin name"
                    onBlur={(e: any) => {
                        handleCheckCampaign(e.target.value);
                    }}
                />
                {isValidate && (!prevName || prevName.trim() === '') && <span className="common_error">Please enter name</span>}
                {error && (prevName !== name) && <span className="common_error">{error}</span>}
            </div>
            <PNormalTextArea className="md:rounded md:py-2 text-xs" rows={3} value={description} name="description" title="Campaign Description" onChange={onFormFieldChange} placeholder="Enter campagin description" />
        </div>
    );
};

export default PInputNameDes;
